import { Card } from "@/ui/atoms/Card";

export type TViewWelcomeParams = {
    useCases: () => {
        /** Name of the company the user acts as (own, or viewed-as). */
        useCompanyName: () => string | null;
        /** Display name of that company's customer module, if it has one. */
        useCustomerModuleName: () => string | null;
    };
};

export type TViewWelcomeProps = Record<string, never>;

/**
 * Landing page for a company whose customer module offers no file pages yet,
 * or that has no customer module. It needs no permission and calls no
 * customer-module API, so it always renders.
 */
export const createViewWelcome = ({ useCases }: TViewWelcomeParams) => {
    return function ViewWelcome() {
        const { useCompanyName, useCustomerModuleName } = useCases();
        const companyName = useCompanyName();
        const customerModuleName = useCustomerModuleName();

        return (
            <div className="p-6">
                <Card className="max-w-2xl p-8 space-y-3" data-testid="welcome-page">
                    <h1 className="text-2xl font-semibold text-balance">
                        Welcome to PRODA Finance
                    </h1>
                    <p className="text-muted-foreground">
                        {companyName ? `${companyName}'s` : "Your company's"} workspace is being set
                        up
                        {customerModuleName ? ` (${customerModuleName})` : ""}. File upload, review
                        and exports appear in the menu as they become available.
                    </p>
                    <p className="text-muted-foreground">
                        Anything you can already use, such as support and user management, is in the
                        menu on the left.
                    </p>
                </Card>
            </div>
        );
    };
};
